<!-- ==================== Meta Tags Table Section ==================== -->
<div class="grid grid-cols-2 gap-4 p-4">
  <!-- <div class="col-span-2">
    <h2 class="text-lg font-semibold mb-2">{{ 'Meta-tags-table' | translate }}</h2>
  </div> -->

  <div class="col-span-2">
    <div class="flex justify-center w-full">
      <div class="w-full md:w-3/4">
        <generic-table rowsId="key" [config]="dcMetaTagTableConfig" [columns]="dcMetaTagColumns"
          [data]="metaTagTableData$ | async" [pagingConfig]="metaTagTablePaginationConfig"
          (rowClicked$)="onRowClick($event)" (rowDblClicked$)="onRowDoubleClick($event)" />
      </div>
    </div>
  </div>
</div>

<!-- ==================== Edit Tag Dialog ==================== -->
<ng-template DcDialog="editTagRef" [borderColor]="'primary'" [hasbackdrop]="true">
  <mat-card class="p-4">
    <mat-card-header class="justify-center">
      <mat-card-title class="text-lg font-semibold text-primary-700">
        {{ 'edit-tag' | translate }}
      </mat-card-title>
    </mat-card-header>

    <mat-card-content [formGroup]="editTagFG" class="grid grid-cols-2 gap-4 p-4">
      <mat-form-field appearance="outline" class="col-span-2">
        <mat-label>{{ 'key' | translate }}</mat-label>
        <input matInput formControlName="key" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-span-2">
        <mat-label>{{ 'value' | translate }}</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
    </mat-card-content>

    <mat-card-actions class="flex justify-around p-4">
      <button mat-button mat-stroked-button color="primary"
        (click)="dcDialogControl.close('editTagRef', { edit: false })" matDialogClose>
        {{ 'cancel-button' | translate }}
      </button>
      <button mat-button mat-raised-button color="primary" [disabled]="!editTagFG.valid" (click)="dcDialogControl.close('editTagRef', {
          edit: true,
          key: editTagFG.get('key')?.value,
          name: editTagFG.get('name')?.value
        })">
        {{ 'update' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</ng-template>

<!-- ==================== Create Tag Dialog ==================== -->
<ng-template DcDialog="createTagRef" [borderColor]="'primary'" [hasbackdrop]="true">
  <mat-card class="p-4">
    <mat-card-header class="justify-center">
      <mat-card-title class="text-lg font-semibold text-primary-700">
        {{ 'create-new-tag' | translate }}
      </mat-card-title>
    </mat-card-header>

    <mat-card-content [formGroup]="createTagFG" class="grid grid-cols-2 gap-4 p-4">
      <mat-form-field appearance="outline" class="col-span-2">
        <mat-label>{{ 'key' | translate }}</mat-label>
        <input matInput formControlName="key" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-span-2">
        <mat-label>{{ 'value' | translate }}</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
    </mat-card-content>

    <mat-card-actions class="flex justify-around p-4">
      <button mat-button mat-stroked-button color="primary"
        (click)="dcDialogControl.close('createTagRef', { create: false })" matDialogClose>
        {{ 'cancel-button' | translate }}
      </button>
      <button mat-button mat-raised-button color="primary" [disabled]="!createTagFG.valid" (click)="dcDialogControl.close('createTagRef', {
          create: true,
          key: createTagFG.get('key')?.value,
          name: createTagFG.get('name')?.value
        })">
        {{ 'create' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</ng-template>

<!-- ==================== Restore Tag Dialog ==================== -->
<ng-template DcDialog="restoreTagRef" [borderColor]="'primary'" [hasbackdrop]="true">
  <mat-card class="p-4">
    <mat-card-header class="justify-center">
      <mat-card-title class="text-lg font-semibold text-primary-700">
        {{ 'create-new-tag' | translate }}
      </mat-card-title>
    </mat-card-header>

    <mat-card-content class="p-4">
      <p>{{ 'struct.metatageditor.restore.description' | translate }}</p>
    </mat-card-content>

    <mat-card-actions class="flex justify-around p-4">
      <button mat-button mat-stroked-button color="primary"
        (click)="dcDialogControl.close('restoreTagRef', { restore: false })" matDialogClose>
        {{ 'struct.metatageditor.restore.decline' | translate }}
      </button>
      <button mat-button mat-raised-button color="primary"
        (click)="dcDialogControl.close('restoreTagRef', { restore: true })">
        {{ 'struct.metatageditor.restore.accept' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</ng-template>